import React, { PureComponent } from 'react';

class SelectorFechaSaldos extends PureComponent {
    constructor(props) {
        super(props);    
        this.state = {
            fecha: this.props.fecha
        }
        this.actualizaFecha = this.actualizaFecha.bind(this);
    }

    actualizaFecha(fecha) {        
        this.setState({
            fecha: fecha 
        });
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ fecha: nextProps.fecha });
    }

    onClickFunction(event) {
        let result = event.key == " " ? false : true;
        if (!result) {
            event.preventDefault();
        }   
        var rgx = /^[0-9]*\/?[0-9]*$/;
        let resp = rgx.test(event.key);

        if (!resp) {
            event.preventDefault();
        }
    }

    handleChange = (e) => {        
        let result = e.target.value == " " ? false : true;
        if (!result) {
            e.preventDefault();
        }   
        //Regex que permite solo números y /
        let regFecha = /^[0-9]*\/?[0-9]*$/;
        //Valida que tenga el formato MM/AAAA
        let regFechaTotal = /^(0[1-9]|1[0-2])\/?([0-9]{4})$/;

        let resp = regFecha.test(e.target.value);

        if (resp) {
            this.actualizaFecha(e.target.value);
            if(regFechaTotal.test(e.target.value))
                this.props.validarFormatoFecha(e.target.value,true);
            else
                this.props.validarFormatoFecha(e.target.value,false);
        }
        else{
            e.preventDefault();
        }  
    }

    render() {

        return (
            <div>
                {!this.props.noLabel && <div className={this.props.classLabel}>{this.props.titulo}</div>}
                    <div>
                            <input
                                id="dateSaldosInput"
                                name="dateSaldosInput"
                                type="text"
                                maxLength="7"
                                value={this.state.fecha}
                                onChange={this.handleChange} 
                                onKeyPress={this.onClickFunction}
                                className="Selector-Fecha-Saldos form-control default-input"
                                autoComplete="off"

                            />
                    </div>
            </div>
        );
    }
}

export default SelectorFechaSaldos;